import { createSelector } from '@ngrx/store';
import { cartState } from '../root';
import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

export const isCartCollectionTypeDineIn = createSelector(cartState, (cart) => {
    if (!cart?.orderTypeId) return false;

    const config = new Statics.ConfigStatic().current;

    return new Utils.CollectionTypeGroupDetector(cart.orderTypeId, config).isDineIn();
});
